<template>
  <div>
    <SiruiTable
      ref="siruiTableRef"
      :loading="loading"
      :data="tableData"
      :paging="false"
      :setting="false"
      :auto-resize="true"
      :showToolbar="false"
      resizable
      :columns="tableColumns"
      :cellClick="cellClick"
      height="300"
    >
      <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) in tableColumns"
        :key="index"
        :fixed="item.fixed"
        :sortable="item.sortable"
        :field="item.field"
        :title="item.title"
        :visible="item.visible"
        :type="item.type"
        :formatter="item.formatter"
        :width="item.width"
        :className="item.className ? item.className : ''"
      >
      </vxe-table-column>
    </SiruiTable>
  </div>
</template>

<script>
  import { tableColumns } from './index';
  import PROJECT_API from '@/api/intermodality/project';
  export default {
    name: 'ChangeRecord',
    data() {
      return {
        tableData: [],
        loading: false,
      };
    },
    computed: {
      tableColumns() {
        return tableColumns();
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.getData();
      });
    },
    methods: {
      cellClick({ row }) {
        console.log(row.projectCode);
        const query = {
          origin: 'record',
          pageMode: 1,
          projectCode: row.projectCode,
          changeId: row.id,
        };
        this.toDetailPage(query);
      },
      async getData() {
        // 获取数据 getMtoContractHistoricalVersion
        const { data } = await this.$axios.post(PROJECT_API.CHANGE_RECORD, {
          projectCode: this.$route.query.projectCode,
        });
        this.tableData = data.data;
      },
      toDetailPage(params = {}) {
        let suffix = 'projectHistoryDetail',
          name = '项目历史';

        let path = {
          path: '/intermodality/' + suffix,
          name: suffix,
          meta: {
            keepAlive: true,
            title: name,
          },
          query: params,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>

<style lang="scss">
  .link-color {
    color: #409eff;
    cursor: pointer;
  }
</style>
